<template>
  <span>
    <img class :src="flag" height="16" />
    <span v-if="!hideText">
      {{ text | translate }}
    </span>
  </span>
</template>

<script>
export default {
  props: ["langCode", "hideText"],
  computed: {
    languages() {
      return this.$store.getters["localization/languages"];
    },

    text() {
      return this.languages.find((i) => i.language == this.langCode)?.title;
    },
    flag() {
      return this.languages.find((i) => i.language == this.langCode)?.flag;
    },
  },
};
</script>
